import Ne, { useState as Rr, useEffect as Re, forwardRef as Cr } from "react";
import { MarketBanner as Br } from "@market/react";
import { useAsyncError as Ar, useRouteError as Ir, UNSAFE_DataRouterContext as wr } from "react-router-dom";
import { I18nextProvider as Or, useTranslation as Lr } from "react-i18next";
import Nr, { createInstance as Dr } from "i18next";
var ue = { exports: {} }, Q = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ut;
function Ur() {
  if (ut) return Q;
  ut = 1;
  var e = Ne, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(h, c, p) {
    var l, m = {}, d = null, H = null;
    p !== void 0 && (d = "" + p), c.key !== void 0 && (d = "" + c.key), c.ref !== void 0 && (H = c.ref);
    for (l in c) n.call(c, l) && !o.hasOwnProperty(l) && (m[l] = c[l]);
    if (h && h.defaultProps) for (l in c = h.defaultProps, c) m[l] === void 0 && (m[l] = c[l]);
    return { $$typeof: t, type: h, key: d, ref: H, props: m, _owner: a.current };
  }
  return Q.Fragment = r, Q.jsx = s, Q.jsxs = s, Q;
}
var K = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ht;
function Mr() {
  return ht || (ht = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ne, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), h = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), H = Symbol.for("react.offscreen"), I = Symbol.iterator, O = "@@iterator";
    function U(i) {
      if (i === null || typeof i != "object")
        return null;
      var u = I && i[I] || i[O];
      return typeof u == "function" ? u : null;
    }
    var L = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function P(i) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), v = 1; v < u; v++)
          f[v - 1] = arguments[v];
        N("error", i, f);
      }
    }
    function N(i, u, f) {
      {
        var v = L.ReactDebugCurrentFrame, _ = v.getStackAddendum();
        _ !== "" && (u += "%s", f = f.concat([_]));
        var S = f.map(function(E) {
          return String(E);
        });
        S.unshift("Warning: " + u), Function.prototype.apply.call(console[i], console, S);
      }
    }
    var G = !1, M = !1, X = !1, ne = !1, qt = !1, Ue;
    Ue = Symbol.for("react.module.reference");
    function Qt(i) {
      return !!(typeof i == "string" || typeof i == "function" || i === n || i === o || qt || i === a || i === p || i === l || ne || i === H || G || M || X || typeof i == "object" && i !== null && (i.$$typeof === d || i.$$typeof === m || i.$$typeof === s || i.$$typeof === h || i.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      i.$$typeof === Ue || i.getModuleId !== void 0));
    }
    function Kt(i, u, f) {
      var v = i.displayName;
      if (v)
        return v;
      var _ = u.displayName || u.name || "";
      return _ !== "" ? f + "(" + _ + ")" : f;
    }
    function Me(i) {
      return i.displayName || "Context";
    }
    function F(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && P("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case h:
            var u = i;
            return Me(u) + ".Consumer";
          case s:
            var f = i;
            return Me(f._context) + ".Provider";
          case c:
            return Kt(i, i.render, "ForwardRef");
          case m:
            var v = i.displayName || null;
            return v !== null ? v : F(i.type) || "Memo";
          case d: {
            var _ = i, S = _._payload, E = _._init;
            try {
              return F(E(S));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, J = 0, ke, Fe, Ge, je, Ve, Xe, We;
    function ze() {
    }
    ze.__reactDisabledLog = !0;
    function er() {
      {
        if (J === 0) {
          ke = console.log, Fe = console.info, Ge = console.warn, je = console.error, Ve = console.group, Xe = console.groupCollapsed, We = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: ze,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        J++;
      }
    }
    function tr() {
      {
        if (J--, J === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, i, {
              value: ke
            }),
            info: j({}, i, {
              value: Fe
            }),
            warn: j({}, i, {
              value: Ge
            }),
            error: j({}, i, {
              value: je
            }),
            group: j({}, i, {
              value: Ve
            }),
            groupCollapsed: j({}, i, {
              value: Xe
            }),
            groupEnd: j({}, i, {
              value: We
            })
          });
        }
        J < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = L.ReactCurrentDispatcher, de;
    function ie(i, u, f) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (_) {
            var v = _.stack.trim().match(/\n( *(at )?)/);
            de = v && v[1] || "";
          }
        return `
` + de + i;
      }
    }
    var me = !1, ae;
    {
      var rr = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new rr();
    }
    function $e(i, u) {
      if (!i || me)
        return "";
      {
        var f = ae.get(i);
        if (f !== void 0)
          return f;
      }
      var v;
      me = !0;
      var _ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var S;
      S = pe.current, pe.current = null, er();
      try {
        if (u) {
          var E = function() {
            throw Error();
          };
          if (Object.defineProperty(E.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(E, []);
            } catch (w) {
              v = w;
            }
            Reflect.construct(i, [], E);
          } else {
            try {
              E.call();
            } catch (w) {
              v = w;
            }
            i.call(E.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (w) {
            v = w;
          }
          i();
        }
      } catch (w) {
        if (w && v && typeof w.stack == "string") {
          for (var g = w.stack.split(`
`), B = v.stack.split(`
`), R = g.length - 1, C = B.length - 1; R >= 1 && C >= 0 && g[R] !== B[C]; )
            C--;
          for (; R >= 1 && C >= 0; R--, C--)
            if (g[R] !== B[C]) {
              if (R !== 1 || C !== 1)
                do
                  if (R--, C--, C < 0 || g[R] !== B[C]) {
                    var D = `
` + g[R].replace(" at new ", " at ");
                    return i.displayName && D.includes("<anonymous>") && (D = D.replace("<anonymous>", i.displayName)), typeof i == "function" && ae.set(i, D), D;
                  }
                while (R >= 1 && C >= 0);
              break;
            }
        }
      } finally {
        me = !1, pe.current = S, tr(), Error.prepareStackTrace = _;
      }
      var z = i ? i.displayName || i.name : "", V = z ? ie(z) : "";
      return typeof i == "function" && ae.set(i, V), V;
    }
    function nr(i, u, f) {
      return $e(i, !1);
    }
    function ir(i) {
      var u = i.prototype;
      return !!(u && u.isReactComponent);
    }
    function oe(i, u, f) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return $e(i, ir(i));
      if (typeof i == "string")
        return ie(i);
      switch (i) {
        case p:
          return ie("Suspense");
        case l:
          return ie("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case c:
            return nr(i.render);
          case m:
            return oe(i.type, u, f);
          case d: {
            var v = i, _ = v._payload, S = v._init;
            try {
              return oe(S(_), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var q = Object.prototype.hasOwnProperty, Ye = {}, Ze = L.ReactDebugCurrentFrame;
    function se(i) {
      if (i) {
        var u = i._owner, f = oe(i.type, i._source, u ? u.type : null);
        Ze.setExtraStackFrame(f);
      } else
        Ze.setExtraStackFrame(null);
    }
    function ar(i, u, f, v, _) {
      {
        var S = Function.call.bind(q);
        for (var E in i)
          if (S(i, E)) {
            var g = void 0;
            try {
              if (typeof i[E] != "function") {
                var B = Error((v || "React class") + ": " + f + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw B.name = "Invariant Violation", B;
              }
              g = i[E](u, E, v, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (R) {
              g = R;
            }
            g && !(g instanceof Error) && (se(_), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", f, E, typeof g), se(null)), g instanceof Error && !(g.message in Ye) && (Ye[g.message] = !0, se(_), P("Failed %s type: %s", f, g.message), se(null));
          }
      }
    }
    var or = Array.isArray;
    function ve(i) {
      return or(i);
    }
    function sr(i) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return f;
      }
    }
    function ur(i) {
      try {
        return Je(i), !1;
      } catch {
        return !0;
      }
    }
    function Je(i) {
      return "" + i;
    }
    function qe(i) {
      if (ur(i))
        return P("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", sr(i)), Je(i);
    }
    var Qe = L.ReactCurrentOwner, hr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ke, et;
    function lr(i) {
      if (q.call(i, "ref")) {
        var u = Object.getOwnPropertyDescriptor(i, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return i.ref !== void 0;
    }
    function fr(i) {
      if (q.call(i, "key")) {
        var u = Object.getOwnPropertyDescriptor(i, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return i.key !== void 0;
    }
    function cr(i, u) {
      typeof i.ref == "string" && Qe.current;
    }
    function pr(i, u) {
      {
        var f = function() {
          Ke || (Ke = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(i, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function dr(i, u) {
      {
        var f = function() {
          et || (et = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(i, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var mr = function(i, u, f, v, _, S, E) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: i,
        key: u,
        ref: f,
        props: E,
        // Record the component responsible for creating this element.
        _owner: S
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function vr(i, u, f, v, _) {
      {
        var S, E = {}, g = null, B = null;
        f !== void 0 && (qe(f), g = "" + f), fr(u) && (qe(u.key), g = "" + u.key), lr(u) && (B = u.ref, cr(u, _));
        for (S in u)
          q.call(u, S) && !hr.hasOwnProperty(S) && (E[S] = u[S]);
        if (i && i.defaultProps) {
          var R = i.defaultProps;
          for (S in R)
            E[S] === void 0 && (E[S] = R[S]);
        }
        if (g || B) {
          var C = typeof i == "function" ? i.displayName || i.name || "Unknown" : i;
          g && pr(E, C), B && dr(E, C);
        }
        return mr(i, g, B, _, v, Qe.current, E);
      }
    }
    var ge = L.ReactCurrentOwner, tt = L.ReactDebugCurrentFrame;
    function W(i) {
      if (i) {
        var u = i._owner, f = oe(i.type, i._source, u ? u.type : null);
        tt.setExtraStackFrame(f);
      } else
        tt.setExtraStackFrame(null);
    }
    var be;
    be = !1;
    function Ee(i) {
      return typeof i == "object" && i !== null && i.$$typeof === t;
    }
    function rt() {
      {
        if (ge.current) {
          var i = F(ge.current.type);
          if (i)
            return `

Check the render method of \`` + i + "`.";
        }
        return "";
      }
    }
    function gr(i) {
      return "";
    }
    var nt = {};
    function br(i) {
      {
        var u = rt();
        if (!u) {
          var f = typeof i == "string" ? i : i.displayName || i.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function it(i, u) {
      {
        if (!i._store || i._store.validated || i.key != null)
          return;
        i._store.validated = !0;
        var f = br(u);
        if (nt[f])
          return;
        nt[f] = !0;
        var v = "";
        i && i._owner && i._owner !== ge.current && (v = " It was passed a child from " + F(i._owner.type) + "."), W(i), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, v), W(null);
      }
    }
    function at(i, u) {
      {
        if (typeof i != "object")
          return;
        if (ve(i))
          for (var f = 0; f < i.length; f++) {
            var v = i[f];
            Ee(v) && it(v, u);
          }
        else if (Ee(i))
          i._store && (i._store.validated = !0);
        else if (i) {
          var _ = U(i);
          if (typeof _ == "function" && _ !== i.entries)
            for (var S = _.call(i), E; !(E = S.next()).done; )
              Ee(E.value) && it(E.value, u);
        }
      }
    }
    function Er(i) {
      {
        var u = i.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === m))
          f = u.propTypes;
        else
          return;
        if (f) {
          var v = F(u);
          ar(f, i.props, "prop", v, i);
        } else if (u.PropTypes !== void 0 && !be) {
          be = !0;
          var _ = F(u);
          P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xr(i) {
      {
        for (var u = Object.keys(i.props), f = 0; f < u.length; f++) {
          var v = u[f];
          if (v !== "children" && v !== "key") {
            W(i), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), W(null);
            break;
          }
        }
        i.ref !== null && (W(i), P("Invalid attribute `ref` supplied to `React.Fragment`."), W(null));
      }
    }
    var ot = {};
    function st(i, u, f, v, _, S) {
      {
        var E = Qt(i);
        if (!E) {
          var g = "";
          (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var B = gr();
          B ? g += B : g += rt();
          var R;
          i === null ? R = "null" : ve(i) ? R = "array" : i !== void 0 && i.$$typeof === t ? (R = "<" + (F(i.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : R = typeof i, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, g);
        }
        var C = vr(i, u, f, _, S);
        if (C == null)
          return C;
        if (E) {
          var D = u.children;
          if (D !== void 0)
            if (v)
              if (ve(D)) {
                for (var z = 0; z < D.length; z++)
                  at(D[z], i);
                Object.freeze && Object.freeze(D);
              } else
                P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              at(D, i);
        }
        if (q.call(u, "key")) {
          var V = F(i), w = Object.keys(u).filter(function(Pr) {
            return Pr !== "key";
          }), xe = w.length > 0 ? "{key: someKey, " + w.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ot[V + xe]) {
            var Hr = w.length > 0 ? "{" + w.join(": ..., ") + ": ...}" : "{}";
            P(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, xe, V, Hr, V), ot[V + xe] = !0;
          }
        }
        return i === n ? xr(C) : Er(C), C;
      }
    }
    function yr(i, u, f) {
      return st(i, u, f, !0);
    }
    function _r(i, u, f) {
      return st(i, u, f, !1);
    }
    var Sr = _r, Tr = yr;
    K.Fragment = n, K.jsx = Sr, K.jsxs = Tr;
  }()), K;
}
var lt;
function kr() {
  return lt || (lt = 1, process.env.NODE_ENV === "production" ? ue.exports = Ur() : ue.exports = Mr()), ue.exports;
}
var k = kr();
function Ct(e, t, r) {
  function n(h) {
    return h && h.indexOf("###") > -1 ? h.replace(/###/g, ".") : h;
  }
  function a() {
    return !e || typeof e == "string";
  }
  for (var o = typeof t != "string" ? [].concat(t) : t.split("."); o.length > 1; ) {
    if (a()) return {};
    var s = n(o.shift());
    !e[s] && r && (e[s] = new r()), e = e[s];
  }
  return a() ? {} : {
    obj: e,
    k: n(o.shift())
  };
}
function Fr(e, t, r) {
  var n = Ct(e, t, Object), a = n.obj, o = n.k;
  a[o] = r;
}
function Gr(e, t) {
  var r = Ct(e, t), n = r.obj, a = r.k;
  if (n)
    return n[a];
}
var Bt = [], jr = Bt.forEach, Vr = Bt.slice;
function Xr(e) {
  return jr.call(Vr.call(arguments, 1), function(t) {
    if (t)
      for (var r in t)
        e[r] === void 0 && (e[r] = t[r]);
  }), e;
}
var Ce = function(e, t) {
  return Ce = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, Ce(e, t);
};
function fe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Ce(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var y = function() {
  return y = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, y.apply(this, arguments);
};
function Wr(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function ye(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, o; n < a; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var b;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(b || (b = {}));
var T;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(T || (T = {}));
var Y;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(Y || (Y = {}));
function ft(e) {
  return e.type === T.literal;
}
function zr(e) {
  return e.type === T.argument;
}
function At(e) {
  return e.type === T.number;
}
function It(e) {
  return e.type === T.date;
}
function wt(e) {
  return e.type === T.time;
}
function Ot(e) {
  return e.type === T.select;
}
function Lt(e) {
  return e.type === T.plural;
}
function $r(e) {
  return e.type === T.pound;
}
function Nt(e) {
  return e.type === T.tag;
}
function Dt(e) {
  return !!(e && typeof e == "object" && e.type === Y.number);
}
function Be(e) {
  return !!(e && typeof e == "object" && e.type === Y.dateTime);
}
var Ut = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Yr = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Zr(e) {
  var t = {};
  return e.replace(Yr, function(r) {
    var n = r.length;
    switch (r[0]) {
      // Era
      case "G":
        t.era = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      // Year
      case "y":
        t.year = n === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      // Quarter
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      // Month
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
        break;
      // Week
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][n - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      // Weekday
      case "E":
        t.weekday = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "e":
        if (n < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "c":
        if (n < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      // Period
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      // am, pm, noon, midnight
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      // Hour
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      // Minute
      case "m":
        t.minute = ["numeric", "2-digit"][n - 1];
        break;
      // Second
      case "s":
        t.second = ["numeric", "2-digit"][n - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      // Zone
      case "z":
        t.timeZoneName = n < 4 ? "short" : "long";
        break;
      case "Z":
      // 1..3, 4, 5: The ISO8601 varios formats
      case "O":
      // 1, 4: milliseconds in day short, long
      case "v":
      // 1, 4: generic non-location format
      case "V":
      // 1, 2, 3, 4: time zone ID or city
      case "X":
      // 1, 2, 3, 4: The ISO8601 varios formats
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var Jr = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function qr(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(Jr).filter(function(d) {
    return d.length > 0;
  }), r = [], n = 0, a = t; n < a.length; n++) {
    var o = a[n], s = o.split("/");
    if (s.length === 0)
      throw new Error("Invalid number skeleton");
    for (var h = s[0], c = s.slice(1), p = 0, l = c; p < l.length; p++) {
      var m = l[p];
      if (m.length === 0)
        throw new Error("Invalid number skeleton");
    }
    r.push({ stem: h, options: c });
  }
  return r;
}
function Qr(e) {
  return e.replace(/^(.*?)-/, "");
}
var ct = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, Mt = /^(@+)?(\+|#+)?[rs]?$/g, Kr = /(\*)(0+)|(#+)(0+)|(0+)/g, kt = /^(0+)$/;
function pt(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(Mt, function(r, n, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length) : a === "+" ? t.minimumSignificantDigits = n.length : n[0] === "#" ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function Ft(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function en(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var r = e.slice(0, 2);
    if (r === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : r === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !kt.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function dt(e) {
  var t = {}, r = Ft(e);
  return r || t;
}
function tn(e) {
  for (var t = {}, r = 0, n = e; r < n.length; r++) {
    var a = n[r];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = Qr(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = y(y(y({}, t), { notation: "scientific" }), a.options.reduce(function(c, p) {
          return y(y({}, c), dt(p));
        }, {}));
        continue;
      case "engineering":
        t = y(y(y({}, t), { notation: "engineering" }), a.options.reduce(function(c, p) {
          return y(y({}, c), dt(p));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(Kr, function(c, p, l, m, d, H) {
          if (p)
            t.minimumIntegerDigits = l.length;
          else {
            if (m && d)
              throw new Error("We currently do not support maximum integer digits");
            if (H)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (kt.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (ct.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(ct, function(c, p, l, m, d, H) {
        return l === "*" ? t.minimumFractionDigits = p.length : m && m[0] === "#" ? t.maximumFractionDigits = m.length : d && H ? (t.minimumFractionDigits = d.length, t.maximumFractionDigits = d.length + H.length) : (t.minimumFractionDigits = p.length, t.maximumFractionDigits = p.length), "";
      });
      var o = a.options[0];
      o === "w" ? t = y(y({}, t), { trailingZeroDisplay: "stripIfInteger" }) : o && (t = y(y({}, t), pt(o)));
      continue;
    }
    if (Mt.test(a.stem)) {
      t = y(y({}, t), pt(a.stem));
      continue;
    }
    var s = Ft(a.stem);
    s && (t = y(y({}, t), s));
    var h = en(a.stem);
    h && (t = y(y({}, t), h));
  }
  return t;
}
var he = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function rn(e, t) {
  for (var r = "", n = 0; n < e.length; n++) {
    var a = e.charAt(n);
    if (a === "j") {
      for (var o = 0; n + 1 < e.length && e.charAt(n + 1) === a; )
        o++, n++;
      var s = 1 + (o & 1), h = o < 2 ? 1 : 3 + (o >> 1), c = "a", p = nn(t);
      for ((p == "H" || p == "k") && (h = 0); h-- > 0; )
        r += c;
      for (; s-- > 0; )
        r = p + r;
    } else a === "J" ? r += "H" : r += a;
  }
  return r;
}
function nn(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var r = e.language, n;
  r !== "root" && (n = e.maximize().region);
  var a = he[n || ""] || he[r || ""] || he["".concat(r, "-001")] || he["001"];
  return a[0];
}
var _e, an = new RegExp("^".concat(Ut.source, "*")), on = new RegExp("".concat(Ut.source, "*$"));
function x(e, t) {
  return { start: e, end: t };
}
var sn = !!String.prototype.startsWith && "_a".startsWith("a", 1), un = !!String.fromCodePoint, hn = !!Object.fromEntries, ln = !!String.prototype.codePointAt, fn = !!String.prototype.trimStart, cn = !!String.prototype.trimEnd, pn = !!Number.isSafeInteger, dn = pn ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, Ae = !0;
try {
  var mn = jt("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Ae = ((_e = mn.exec("a")) === null || _e === void 0 ? void 0 : _e[0]) === "a";
} catch {
  Ae = !1;
}
var mt = sn ? (
  // Native
  function(t, r, n) {
    return t.startsWith(r, n);
  }
) : (
  // For IE11
  function(t, r, n) {
    return t.slice(n, n + r.length) === r;
  }
), Ie = un ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    for (var n = "", a = t.length, o = 0, s; a > o; ) {
      if (s = t[o++], s > 1114111)
        throw RangeError(s + " is not a valid code point");
      n += s < 65536 ? String.fromCharCode(s) : String.fromCharCode(((s -= 65536) >> 10) + 55296, s % 1024 + 56320);
    }
    return n;
  }
), vt = (
  // native
  hn ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var r = {}, n = 0, a = t; n < a.length; n++) {
        var o = a[n], s = o[0], h = o[1];
        r[s] = h;
      }
      return r;
    }
  )
), Gt = ln ? (
  // Native
  function(t, r) {
    return t.codePointAt(r);
  }
) : (
  // IE 11
  function(t, r) {
    var n = t.length;
    if (!(r < 0 || r >= n)) {
      var a = t.charCodeAt(r), o;
      return a < 55296 || a > 56319 || r + 1 === n || (o = t.charCodeAt(r + 1)) < 56320 || o > 57343 ? a : (a - 55296 << 10) + (o - 56320) + 65536;
    }
  }
), vn = fn ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(an, "");
  }
), gn = cn ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(on, "");
  }
);
function jt(e, t) {
  return new RegExp(e, t);
}
var we;
if (Ae) {
  var gt = jt("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  we = function(t, r) {
    var n;
    gt.lastIndex = r;
    var a = gt.exec(t);
    return (n = a[1]) !== null && n !== void 0 ? n : "";
  };
} else
  we = function(t, r) {
    for (var n = []; ; ) {
      var a = Gt(t, r);
      if (a === void 0 || Vt(a) || yn(a))
        break;
      n.push(a), r += a >= 65536 ? 2 : 1;
    }
    return Ie.apply(void 0, n);
  };
var bn = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!r.ignoreTag, this.locale = r.locale, this.requiresOtherClause = !!r.requiresOtherClause, this.shouldParseSkeletons = !!r.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, r, n) {
      for (var a = []; !this.isEOF(); ) {
        var o = this.char();
        if (o === 123) {
          var s = this.parseArgument(t, n);
          if (s.err)
            return s;
          a.push(s.val);
        } else {
          if (o === 125 && t > 0)
            break;
          if (o === 35 && (r === "plural" || r === "selectordinal")) {
            var h = this.clonePosition();
            this.bump(), a.push({
              type: T.pound,
              location: x(h, this.clonePosition())
            });
          } else if (o === 60 && !this.ignoreTag && this.peek() === 47) {
            if (n)
              break;
            return this.error(b.UNMATCHED_CLOSING_TAG, x(this.clonePosition(), this.clonePosition()));
          } else if (o === 60 && !this.ignoreTag && Oe(this.peek() || 0)) {
            var s = this.parseTag(t, r);
            if (s.err)
              return s;
            a.push(s.val);
          } else {
            var s = this.parseLiteral(t, r);
            if (s.err)
              return s;
            a.push(s.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(t, r) {
      var n = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: T.literal,
            value: "<".concat(a, "/>"),
            location: x(n, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var o = this.parseMessage(t + 1, r, !0);
        if (o.err)
          return o;
        var s = o.val, h = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !Oe(this.char()))
            return this.error(b.INVALID_TAG, x(h, this.clonePosition()));
          var c = this.clonePosition(), p = this.parseTagName();
          return a !== p ? this.error(b.UNMATCHED_CLOSING_TAG, x(c, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: T.tag,
              value: a,
              children: s,
              location: x(n, this.clonePosition())
            },
            err: null
          } : this.error(b.INVALID_TAG, x(h, this.clonePosition())));
        } else
          return this.error(b.UNCLOSED_TAG, x(n, this.clonePosition()));
      } else
        return this.error(b.INVALID_TAG, x(n, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && xn(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, r) {
      for (var n = this.clonePosition(), a = ""; ; ) {
        var o = this.tryParseQuote(r);
        if (o) {
          a += o;
          continue;
        }
        var s = this.tryParseUnquoted(t, r);
        if (s) {
          a += s;
          continue;
        }
        var h = this.tryParseLeftAngleBracket();
        if (h) {
          a += h;
          continue;
        }
        break;
      }
      var c = x(n, this.clonePosition());
      return {
        val: { type: T.literal, value: a, location: c },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !En(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        // '{', '<', '>', '}'
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var r = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var n = this.char();
        if (n === 39)
          if (this.peek() === 39)
            r.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          r.push(n);
        this.bump();
      }
      return Ie.apply(void 0, r);
    }, e.prototype.tryParseUnquoted = function(t, r) {
      if (this.isEOF())
        return null;
      var n = this.char();
      return n === 60 || n === 123 || n === 35 && (r === "plural" || r === "selectordinal") || n === 125 && t > 0 ? null : (this.bump(), Ie(n));
    }, e.prototype.parseArgument = function(t, r) {
      var n = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(b.EXPECT_ARGUMENT_CLOSING_BRACE, x(n, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(b.EMPTY_ARGUMENT, x(n, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(b.MALFORMED_ARGUMENT, x(n, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(b.EXPECT_ARGUMENT_CLOSING_BRACE, x(n, this.clonePosition()));
      switch (this.char()) {
        // Simple argument: `{name}`
        case 125:
          return this.bump(), {
            val: {
              type: T.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: x(n, this.clonePosition())
            },
            err: null
          };
        // Argument with options: `{name, format, ...}`
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(b.EXPECT_ARGUMENT_CLOSING_BRACE, x(n, this.clonePosition())) : this.parseArgumentOptions(t, r, a, n);
        default:
          return this.error(b.MALFORMED_ARGUMENT, x(n, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), r = this.offset(), n = we(this.message, r), a = r + n.length;
      this.bumpTo(a);
      var o = this.clonePosition(), s = x(t, o);
      return { value: n, location: s };
    }, e.prototype.parseArgumentOptions = function(t, r, n, a) {
      var o, s = this.clonePosition(), h = this.parseIdentifierIfPossible().value, c = this.clonePosition();
      switch (h) {
        case "":
          return this.error(b.EXPECT_ARGUMENT_TYPE, x(s, c));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var p = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var l = this.clonePosition(), m = this.parseSimpleArgStyleIfPossible();
            if (m.err)
              return m;
            var d = gn(m.val);
            if (d.length === 0)
              return this.error(b.EXPECT_ARGUMENT_STYLE, x(this.clonePosition(), this.clonePosition()));
            var H = x(l, this.clonePosition());
            p = { style: d, styleLocation: H };
          }
          var I = this.tryParseArgumentClose(a);
          if (I.err)
            return I;
          var O = x(a, this.clonePosition());
          if (p && mt(p?.style, "::", 0)) {
            var U = vn(p.style.slice(2));
            if (h === "number") {
              var m = this.parseNumberSkeletonFromString(U, p.styleLocation);
              return m.err ? m : {
                val: { type: T.number, value: n, location: O, style: m.val },
                err: null
              };
            } else {
              if (U.length === 0)
                return this.error(b.EXPECT_DATE_TIME_SKELETON, O);
              var L = U;
              this.locale && (L = rn(U, this.locale));
              var d = {
                type: Y.dateTime,
                pattern: L,
                location: p.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? Zr(L) : {}
              }, P = h === "date" ? T.date : T.time;
              return {
                val: { type: P, value: n, location: O, style: d },
                err: null
              };
            }
          }
          return {
            val: {
              type: h === "number" ? T.number : h === "date" ? T.date : T.time,
              value: n,
              location: O,
              style: (o = p?.style) !== null && o !== void 0 ? o : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var N = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(b.EXPECT_SELECT_ARGUMENT_OPTIONS, x(N, y({}, N)));
          this.bumpSpace();
          var G = this.parseIdentifierIfPossible(), M = 0;
          if (h !== "select" && G.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(b.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, x(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var m = this.tryParseDecimalInteger(b.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, b.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (m.err)
              return m;
            this.bumpSpace(), G = this.parseIdentifierIfPossible(), M = m.val;
          }
          var X = this.tryParsePluralOrSelectOptions(t, h, r, G);
          if (X.err)
            return X;
          var I = this.tryParseArgumentClose(a);
          if (I.err)
            return I;
          var ne = x(a, this.clonePosition());
          return h === "select" ? {
            val: {
              type: T.select,
              value: n,
              options: vt(X.val),
              location: ne
            },
            err: null
          } : {
            val: {
              type: T.plural,
              value: n,
              options: vt(X.val),
              offset: M,
              pluralType: h === "plural" ? "cardinal" : "ordinal",
              location: ne
            },
            err: null
          };
        }
        default:
          return this.error(b.INVALID_ARGUMENT_TYPE, x(s, c));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(b.EXPECT_ARGUMENT_CLOSING_BRACE, x(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, r = this.clonePosition(); !this.isEOF(); ) {
        var n = this.char();
        switch (n) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(b.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, x(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(r.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(r.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, r) {
      var n = [];
      try {
        n = qr(t);
      } catch {
        return this.error(b.INVALID_NUMBER_SKELETON, r);
      }
      return {
        val: {
          type: Y.number,
          tokens: n,
          location: r,
          parsedOptions: this.shouldParseSkeletons ? tn(n) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, r, n, a) {
      for (var o, s = !1, h = [], c = /* @__PURE__ */ new Set(), p = a.value, l = a.location; ; ) {
        if (p.length === 0) {
          var m = this.clonePosition();
          if (r !== "select" && this.bumpIf("=")) {
            var d = this.tryParseDecimalInteger(b.EXPECT_PLURAL_ARGUMENT_SELECTOR, b.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (d.err)
              return d;
            l = x(m, this.clonePosition()), p = this.message.slice(m.offset, this.offset());
          } else
            break;
        }
        if (c.has(p))
          return this.error(r === "select" ? b.DUPLICATE_SELECT_ARGUMENT_SELECTOR : b.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, l);
        p === "other" && (s = !0), this.bumpSpace();
        var H = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(r === "select" ? b.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : b.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, x(this.clonePosition(), this.clonePosition()));
        var I = this.parseMessage(t + 1, r, n);
        if (I.err)
          return I;
        var O = this.tryParseArgumentClose(H);
        if (O.err)
          return O;
        h.push([
          p,
          {
            value: I.val,
            location: x(H, this.clonePosition())
          }
        ]), c.add(p), this.bumpSpace(), o = this.parseIdentifierIfPossible(), p = o.value, l = o.location;
      }
      return h.length === 0 ? this.error(r === "select" ? b.EXPECT_SELECT_ARGUMENT_SELECTOR : b.EXPECT_PLURAL_ARGUMENT_SELECTOR, x(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !s ? this.error(b.MISSING_OTHER_CLAUSE, x(this.clonePosition(), this.clonePosition())) : { val: h, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, r) {
      var n = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (n = -1);
      for (var o = !1, s = 0; !this.isEOF(); ) {
        var h = this.char();
        if (h >= 48 && h <= 57)
          o = !0, s = s * 10 + (h - 48), this.bump();
        else
          break;
      }
      var c = x(a, this.clonePosition());
      return o ? (s *= n, dn(s) ? { val: s, err: null } : this.error(r, c)) : this.error(t, c);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var r = Gt(this.message, t);
      if (r === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return r;
    }, e.prototype.error = function(t, r) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: r
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (mt(this.message, t, this.offset())) {
        for (var r = 0; r < t.length; r++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var r = this.offset(), n = this.message.indexOf(t, r);
      return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var r = this.offset();
        if (r === t)
          break;
        if (r > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && Vt(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), r = this.offset(), n = this.message.charCodeAt(r + (t >= 65536 ? 2 : 1));
      return n ?? null;
    }, e;
  }()
);
function Oe(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function En(e) {
  return Oe(e) || e === 47;
}
function xn(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function Vt(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function yn(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function Le(e) {
  e.forEach(function(t) {
    if (delete t.location, Ot(t) || Lt(t))
      for (var r in t.options)
        delete t.options[r].location, Le(t.options[r].value);
    else At(t) && Dt(t.style) || (It(t) || wt(t)) && Be(t.style) ? delete t.style.location : Nt(t) && Le(t.children);
  });
}
function _n(e, t) {
  t === void 0 && (t = {}), t = y({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var r = new bn(e, t).parse();
  if (r.err) {
    var n = SyntaxError(b[r.err.kind]);
    throw n.location = r.err.location, n.originalMessage = r.err.message, n;
  }
  return t?.captureLocation || Le(r.val), r.val;
}
function Se(e, t) {
  var r = t && t.cache ? t.cache : Cn, n = t && t.serializer ? t.serializer : Rn, a = t && t.strategy ? t.strategy : Hn;
  return a(e, {
    cache: r,
    serializer: n
  });
}
function Sn(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function Tn(e, t, r, n) {
  var a = Sn(n) ? n : r(n), o = t.get(a);
  return typeof o > "u" && (o = e.call(this, n), t.set(a, o)), o;
}
function Xt(e, t, r) {
  var n = Array.prototype.slice.call(arguments, 3), a = r(n), o = t.get(a);
  return typeof o > "u" && (o = e.apply(this, n), t.set(a, o)), o;
}
function Wt(e, t, r, n, a) {
  return r.bind(t, e, n, a);
}
function Hn(e, t) {
  var r = e.length === 1 ? Tn : Xt;
  return Wt(e, this, r, t.cache.create(), t.serializer);
}
function Pn(e, t) {
  return Wt(e, this, Xt, t.cache.create(), t.serializer);
}
var Rn = function() {
  return JSON.stringify(arguments);
};
function De() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
De.prototype.get = function(e) {
  return this.cache[e];
};
De.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var Cn = {
  create: function() {
    return new De();
  }
}, Te = {
  variadic: Pn
}, Z;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(Z || (Z = {}));
var ce = (
  /** @class */
  function(e) {
    fe(t, e);
    function t(r, n, a) {
      var o = e.call(this, r) || this;
      return o.code = n, o.originalMessage = a, o;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), bt = (
  /** @class */
  function(e) {
    fe(t, e);
    function t(r, n, a, o) {
      return e.call(this, 'Invalid values for "'.concat(r, '": "').concat(n, '". Options are "').concat(Object.keys(a).join('", "'), '"'), Z.INVALID_VALUE, o) || this;
    }
    return t;
  }(ce)
), Bn = (
  /** @class */
  function(e) {
    fe(t, e);
    function t(r, n, a) {
      return e.call(this, 'Value for "'.concat(r, '" must be of type ').concat(n), Z.INVALID_VALUE, a) || this;
    }
    return t;
  }(ce)
), An = (
  /** @class */
  function(e) {
    fe(t, e);
    function t(r, n) {
      return e.call(this, 'The intl string context variable "'.concat(r, '" was not provided to the string "').concat(n, '"'), Z.MISSING_VALUE, n) || this;
    }
    return t;
  }(ce)
), A;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(A || (A = {}));
function In(e) {
  return e.length < 2 ? e : e.reduce(function(t, r) {
    var n = t[t.length - 1];
    return !n || n.type !== A.literal || r.type !== A.literal ? t.push(r) : n.value += r.value, t;
  }, []);
}
function wn(e) {
  return typeof e == "function";
}
function le(e, t, r, n, a, o, s) {
  if (e.length === 1 && ft(e[0]))
    return [
      {
        type: A.literal,
        value: e[0].value
      }
    ];
  for (var h = [], c = 0, p = e; c < p.length; c++) {
    var l = p[c];
    if (ft(l)) {
      h.push({
        type: A.literal,
        value: l.value
      });
      continue;
    }
    if ($r(l)) {
      typeof o == "number" && h.push({
        type: A.literal,
        value: r.getNumberFormat(t).format(o)
      });
      continue;
    }
    var m = l.value;
    if (!(a && m in a))
      throw new An(m, s);
    var d = a[m];
    if (zr(l)) {
      (!d || typeof d == "string" || typeof d == "number") && (d = typeof d == "string" || typeof d == "number" ? String(d) : ""), h.push({
        type: typeof d == "string" ? A.literal : A.object,
        value: d
      });
      continue;
    }
    if (It(l)) {
      var H = typeof l.style == "string" ? n.date[l.style] : Be(l.style) ? l.style.parsedOptions : void 0;
      h.push({
        type: A.literal,
        value: r.getDateTimeFormat(t, H).format(d)
      });
      continue;
    }
    if (wt(l)) {
      var H = typeof l.style == "string" ? n.time[l.style] : Be(l.style) ? l.style.parsedOptions : n.time.medium;
      h.push({
        type: A.literal,
        value: r.getDateTimeFormat(t, H).format(d)
      });
      continue;
    }
    if (At(l)) {
      var H = typeof l.style == "string" ? n.number[l.style] : Dt(l.style) ? l.style.parsedOptions : void 0;
      H && H.scale && (d = d * (H.scale || 1)), h.push({
        type: A.literal,
        value: r.getNumberFormat(t, H).format(d)
      });
      continue;
    }
    if (Nt(l)) {
      var I = l.children, O = l.value, U = a[O];
      if (!wn(U))
        throw new Bn(O, "function", s);
      var L = le(I, t, r, n, a, o), P = U(L.map(function(M) {
        return M.value;
      }));
      Array.isArray(P) || (P = [P]), h.push.apply(h, P.map(function(M) {
        return {
          type: typeof M == "string" ? A.literal : A.object,
          value: M
        };
      }));
    }
    if (Ot(l)) {
      var N = l.options[d] || l.options.other;
      if (!N)
        throw new bt(l.value, d, Object.keys(l.options), s);
      h.push.apply(h, le(N.value, t, r, n, a));
      continue;
    }
    if (Lt(l)) {
      var N = l.options["=".concat(d)];
      if (!N) {
        if (!Intl.PluralRules)
          throw new ce(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, Z.MISSING_INTL_API, s);
        var G = r.getPluralRules(t, { type: l.pluralType }).select(d - (l.offset || 0));
        N = l.options[G] || l.options.other;
      }
      if (!N)
        throw new bt(l.value, d, Object.keys(l.options), s);
      h.push.apply(h, le(N.value, t, r, n, a, d - (l.offset || 0)));
      continue;
    }
  }
  return In(h);
}
function On(e, t) {
  return t ? y(y(y({}, e || {}), t || {}), Object.keys(e).reduce(function(r, n) {
    return r[n] = y(y({}, e[n]), t[n] || {}), r;
  }, {})) : e;
}
function Ln(e, t) {
  return t ? Object.keys(e).reduce(function(r, n) {
    return r[n] = On(e[n], t[n]), r;
  }, y({}, e)) : e;
}
function He(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, r) {
          e[t] = r;
        }
      };
    }
  };
}
function Nn(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: Se(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.NumberFormat).bind.apply(t, ye([void 0], r, !1)))();
    }, {
      cache: He(e.number),
      strategy: Te.variadic
    }),
    getDateTimeFormat: Se(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, ye([void 0], r, !1)))();
    }, {
      cache: He(e.dateTime),
      strategy: Te.variadic
    }),
    getPluralRules: Se(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.PluralRules).bind.apply(t, ye([void 0], r, !1)))();
    }, {
      cache: He(e.pluralRules),
      strategy: Te.variadic
    })
  };
}
var Et = (
  /** @class */
  function() {
    function e(t, r, n, a) {
      var o = this;
      if (r === void 0 && (r = e.defaultLocale), this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(c) {
        var p = o.formatToParts(c);
        if (p.length === 1)
          return p[0].value;
        var l = p.reduce(function(m, d) {
          return !m.length || d.type !== A.literal || typeof m[m.length - 1] != "string" ? m.push(d.value) : m[m.length - 1] += d.value, m;
        }, []);
        return l.length <= 1 ? l[0] || "" : l;
      }, this.formatToParts = function(c) {
        return le(o.ast, o.locales, o.formatters, o.formats, c, void 0, o.message);
      }, this.resolvedOptions = function() {
        var c;
        return {
          locale: ((c = o.resolvedLocale) === null || c === void 0 ? void 0 : c.toString()) || Intl.NumberFormat.supportedLocalesOf(o.locales)[0]
        };
      }, this.getAst = function() {
        return o.ast;
      }, this.locales = r, this.resolvedLocale = e.resolveLocale(r), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var s = a || {};
        s.formatters;
        var h = Wr(s, ["formatters"]);
        this.ast = e.__parse(t, y(y({}, h), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Ln(e.formats, n), this.formatters = a && a.formatters || Nn(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var r = Intl.NumberFormat.supportedLocalesOf(t);
        return r.length > 0 ? new Intl.Locale(r[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = _n, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
);
function xt(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xt(Object(r), !0).forEach(function(n) {
      Dn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xt(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Dn(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Un(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Mn(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function kn(e, t, r) {
  return t && Mn(e.prototype, t), e;
}
function Fn() {
  return {
    memoize: !0,
    memoizeFallback: !1,
    bindI18n: "",
    bindI18nStore: "",
    parseErrorHandler: function(t, r, n, a) {
      return n;
    },
    parseLngForICU: function(t) {
      return t;
    }
  };
}
var zt = /* @__PURE__ */ function() {
  function e(t) {
    Un(this, e), this.type = "i18nFormat", this.mem = {}, this.init(null, t);
  }
  return kn(e, [{
    key: "init",
    value: function(r, n) {
      var a = this, o = r && r.options && r.options.i18nFormat || {};
      if (this.options = Xr(o, n, this.options || {}, Fn()), this.formats = this.options.formats, r) {
        var s = this.options, h = s.bindI18n, c = s.bindI18nStore, p = s.memoize;
        r.IntlMessageFormat = Et, r.ICU = this, p && (h && r.on(h, function() {
          return a.clearCache();
        }), c && r.store.on(c, function() {
          return a.clearCache();
        }));
      }
    }
  }, {
    key: "addUserDefinedFormats",
    value: function(r) {
      this.formats = this.formats ? yt(yt({}, this.formats), r) : r;
    }
  }, {
    key: "parse",
    value: function(r, n, a, o, s, h) {
      var c = h && h.resolved && h.resolved.res, p = this.options.memoize && "".concat(a, ".").concat(o, ".").concat(s.replace(/\./g, "###")), l;
      this.options.memoize && (l = Gr(this.mem, p));
      try {
        if (!l) {
          var m = this.options.parseLngForICU(a);
          l = new Et(r, m, this.formats, {
            ignoreTag: !0
          }), this.options.memoize && (this.options.memoizeFallback || !h || c) && Fr(this.mem, p, l);
        }
        return l.format(n);
      } catch (d) {
        return this.options.parseErrorHandler(d, s, r, n);
      }
    }
  }, {
    key: "addLookupKeys",
    value: function(r, n, a, o, s) {
      return r;
    }
  }, {
    key: "clearCache",
    value: function() {
      this.mem = {};
    }
  }]), e;
}();
zt.type = "i18nFormat";
function Gn(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function re(e) {
  "@babel/helpers - typeof";
  return re = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, re(e);
}
function jn(e, t) {
  if (re(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (re(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Vn(e) {
  var t = jn(e, "string");
  return re(t) == "symbol" ? t : t + "";
}
function Xn(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Vn(n.key), n);
  }
}
function Wn(e, t, r) {
  return t && Xn(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var $t = [], zn = $t.forEach, $n = $t.slice;
function Yn(e) {
  return zn.call($n.call(arguments, 1), function(t) {
    if (t)
      for (var r in t)
        e[r] === void 0 && (e[r] = t[r]);
  }), e;
}
var _t = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, Zn = function(t, r, n) {
  var a = n || {};
  a.path = a.path || "/";
  var o = encodeURIComponent(r), s = "".concat(t, "=").concat(o);
  if (a.maxAge > 0) {
    var h = a.maxAge - 0;
    if (Number.isNaN(h)) throw new Error("maxAge should be a Number");
    s += "; Max-Age=".concat(Math.floor(h));
  }
  if (a.domain) {
    if (!_t.test(a.domain))
      throw new TypeError("option domain is invalid");
    s += "; Domain=".concat(a.domain);
  }
  if (a.path) {
    if (!_t.test(a.path))
      throw new TypeError("option path is invalid");
    s += "; Path=".concat(a.path);
  }
  if (a.expires) {
    if (typeof a.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    s += "; Expires=".concat(a.expires.toUTCString());
  }
  if (a.httpOnly && (s += "; HttpOnly"), a.secure && (s += "; Secure"), a.sameSite) {
    var c = typeof a.sameSite == "string" ? a.sameSite.toLowerCase() : a.sameSite;
    switch (c) {
      case !0:
        s += "; SameSite=Strict";
        break;
      case "lax":
        s += "; SameSite=Lax";
        break;
      case "strict":
        s += "; SameSite=Strict";
        break;
      case "none":
        s += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return s;
}, St = {
  create: function(t, r, n, a) {
    var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    n && (o.expires = /* @__PURE__ */ new Date(), o.expires.setTime(o.expires.getTime() + n * 60 * 1e3)), a && (o.domain = a), document.cookie = Zn(t, encodeURIComponent(r), o);
  },
  read: function(t) {
    for (var r = "".concat(t, "="), n = document.cookie.split(";"), a = 0; a < n.length; a++) {
      for (var o = n[a]; o.charAt(0) === " "; ) o = o.substring(1, o.length);
      if (o.indexOf(r) === 0) return o.substring(r.length, o.length);
    }
    return null;
  },
  remove: function(t) {
    this.create(t, "", -1);
  }
}, Jn = {
  name: "cookie",
  lookup: function(t) {
    var r;
    if (t.lookupCookie && typeof document < "u") {
      var n = St.read(t.lookupCookie);
      n && (r = n);
    }
    return r;
  },
  cacheUserLanguage: function(t, r) {
    r.lookupCookie && typeof document < "u" && St.create(r.lookupCookie, t, r.cookieMinutes, r.cookieDomain, r.cookieOptions);
  }
}, qn = {
  name: "querystring",
  lookup: function(t) {
    var r;
    if (typeof window < "u") {
      var n = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (n = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var a = n.substring(1), o = a.split("&"), s = 0; s < o.length; s++) {
        var h = o[s].indexOf("=");
        if (h > 0) {
          var c = o[s].substring(0, h);
          c === t.lookupQuerystring && (r = o[s].substring(h + 1));
        }
      }
    }
    return r;
  }
}, ee = null, Tt = function() {
  if (ee !== null) return ee;
  try {
    ee = window !== "undefined" && window.localStorage !== null;
    var t = "i18next.translate.boo";
    window.localStorage.setItem(t, "foo"), window.localStorage.removeItem(t);
  } catch {
    ee = !1;
  }
  return ee;
}, Qn = {
  name: "localStorage",
  lookup: function(t) {
    var r;
    if (t.lookupLocalStorage && Tt()) {
      var n = window.localStorage.getItem(t.lookupLocalStorage);
      n && (r = n);
    }
    return r;
  },
  cacheUserLanguage: function(t, r) {
    r.lookupLocalStorage && Tt() && window.localStorage.setItem(r.lookupLocalStorage, t);
  }
}, te = null, Ht = function() {
  if (te !== null) return te;
  try {
    te = window !== "undefined" && window.sessionStorage !== null;
    var t = "i18next.translate.boo";
    window.sessionStorage.setItem(t, "foo"), window.sessionStorage.removeItem(t);
  } catch {
    te = !1;
  }
  return te;
}, Kn = {
  name: "sessionStorage",
  lookup: function(t) {
    var r;
    if (t.lookupSessionStorage && Ht()) {
      var n = window.sessionStorage.getItem(t.lookupSessionStorage);
      n && (r = n);
    }
    return r;
  },
  cacheUserLanguage: function(t, r) {
    r.lookupSessionStorage && Ht() && window.sessionStorage.setItem(r.lookupSessionStorage, t);
  }
}, ei = {
  name: "navigator",
  lookup: function(t) {
    var r = [];
    if (typeof navigator < "u") {
      if (navigator.languages)
        for (var n = 0; n < navigator.languages.length; n++)
          r.push(navigator.languages[n]);
      navigator.userLanguage && r.push(navigator.userLanguage), navigator.language && r.push(navigator.language);
    }
    return r.length > 0 ? r : void 0;
  }
}, ti = {
  name: "htmlTag",
  lookup: function(t) {
    var r, n = t.htmlTag || (typeof document < "u" ? document.documentElement : null);
    return n && typeof n.getAttribute == "function" && (r = n.getAttribute("lang")), r;
  }
}, ri = {
  name: "path",
  lookup: function(t) {
    var r;
    if (typeof window < "u") {
      var n = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (n instanceof Array)
        if (typeof t.lookupFromPathIndex == "number") {
          if (typeof n[t.lookupFromPathIndex] != "string")
            return;
          r = n[t.lookupFromPathIndex].replace("/", "");
        } else
          r = n[0].replace("/", "");
    }
    return r;
  }
}, ni = {
  name: "subdomain",
  lookup: function(t) {
    var r = typeof t.lookupFromSubdomainIndex == "number" ? t.lookupFromSubdomainIndex + 1 : 1, n = typeof window < "u" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (n)
      return n[r];
  }
};
function ii() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: function(t) {
      return t;
    }
  };
}
var Yt = /* @__PURE__ */ function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Gn(this, e), this.type = "languageDetector", this.detectors = {}, this.init(t, r);
  }
  return Wn(e, [{
    key: "init",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = r || {
        languageUtils: {}
      }, this.options = Yn(n, this.options || {}, ii()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(o) {
        return o.replace("-", "_");
      }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = a, this.addDetector(Jn), this.addDetector(qn), this.addDetector(Qn), this.addDetector(Kn), this.addDetector(ei), this.addDetector(ti), this.addDetector(ri), this.addDetector(ni);
    }
  }, {
    key: "addDetector",
    value: function(r) {
      return this.detectors[r.name] = r, this;
    }
  }, {
    key: "detect",
    value: function(r) {
      var n = this;
      r || (r = this.options.order);
      var a = [];
      return r.forEach(function(o) {
        if (n.detectors[o]) {
          var s = n.detectors[o].lookup(n.options);
          s && typeof s == "string" && (s = [s]), s && (a = a.concat(s));
        }
      }), a = a.map(function(o) {
        return n.options.convertDetectedLanguage(o);
      }), this.services.languageUtils.getBestMatchFromCodes ? a : a.length > 0 ? a[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(r, n) {
      var a = this;
      n || (n = this.options.caches), n && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(r) > -1 || n.forEach(function(o) {
        a.detectors[o] && a.detectors[o].cacheUserLanguage(r, a.options);
      }));
    }
  }]), e;
}();
Yt.type = "languageDetector";
var ai = function(t) {
  return {
    type: "backend",
    init: function(n, a, o) {
    },
    read: function(n, a, o) {
      if (typeof t == "function") {
        if (t.length < 3) {
          try {
            var s = t(n, a);
            s && typeof s.then == "function" ? s.then(function(h) {
              return o(null, h && h.default || h);
            }).catch(o) : o(null, s);
          } catch (h) {
            o(h);
          }
          return;
        }
        t(n, a, o);
        return;
      }
      o(null, t && t[n] && t[n][a]);
    }
  };
};
const Zt = (e) => {
  const t = {
    a: "ȧȧ",
    b: "ƀ",
    c: "ƈ",
    d: "ḓ",
    e: "ḗḗ",
    f: "ƒ",
    g: "ĝ",
    h: "ħ",
    i: "ī",
    j: "ĵ",
    k: "ḳ",
    l: "ŀ",
    m: "ḿ",
    n: "ƞ",
    o: "ǿǿ",
    p: "ƥ",
    q: "ɋ",
    r: "ř",
    s: "ş",
    t: "ŧ",
    u: "ŭ",
    v: "ṽ",
    w: "ŵ",
    x: "ẋ",
    y: "ẏ",
    z: "ẓ",
    A: "ȦȦ",
    B: "Ƀ",
    C: "Ċ",
    D: "Ḓ",
    E: "ḖḖ",
    F: "Ƒ",
    G: "Ĝ",
    H: "Ħ",
    I: "Ī",
    J: "Ĵ",
    K: "Ḳ",
    L: "Ŀ",
    M: "Ṁ",
    N: "Ń",
    O: "ØØ",
    P: "Ᵽ",
    Q: "Ɋ",
    R: "Ŗ",
    S: "Ṡ",
    T: "Ŧ",
    U: "Ů",
    V: "Ṿ",
    W: "Ŵ",
    X: "Ẍ",
    Y: "Ŷ",
    Z: "Ż"
  }, r = (n) => {
    let a = "";
    for (let o = 0; o < n.length; o += 1) {
      const s = n[o];
      a += t[s] || s;
    }
    return a;
  };
  return Object.keys(e).forEach((n) => {
    if (typeof e[n] == "string") {
      const a = e[n].match(
        // https://regex101.com/r/XZEJYe/1
        /\{\{[^}]*\}\}|\{[^}]*\}|<[^>]*>|\||[^{}<>|]+/g
      );
      if (!a?.length)
        return;
      for (let o = 0; o < a.length; o += 1) {
        const s = a[o];
        s && !s.startsWith("<") && // Skip HTML tags
        !s.startsWith("|") && // Skip pipes
        s.match(/^[^{].*[^}]$/) && (a[o] = r(s));
      }
      e[n] = a.join("");
    } else typeof e[n] == "object" && e[n] !== null && Zt(e[n]);
  }), e;
};
globalThis.__serviceI18NResources ??= {};
function Pt(e, t) {
  try {
    globalThis.__serviceI18NResources["shared-ui-error-boundary"] = globalThis.__serviceI18NResources["shared-ui-error-boundary"] || {}, globalThis.__serviceI18NResources["shared-ui-error-boundary"][e] = { translation: t };
  } catch (r) {
    console.error("i18n - Failed to set resource:", r);
  }
}
const Rt = /* @__PURE__ */ Object.assign({ "/src/generated-locales/ca-ES.json": () => import("./ca-ES-CvNgi6uL.js"), "/src/generated-locales/en-AU.json": () => import("./en-AU-CCnUcpRo.js"), "/src/generated-locales/en-CA.json": () => import("./en-CA-CCnUcpRo.js"), "/src/generated-locales/en-GB.json": () => import("./en-GB-CCnUcpRo.js"), "/src/generated-locales/en-IE.json": () => import("./en-IE-CCnUcpRo.js"), "/src/generated-locales/en.json": () => import("./en-BPXPtoaN.js"), "/src/generated-locales/es-ES.json": () => import("./es-ES-aiIOEjwU.js"), "/src/generated-locales/es-MX.json": () => import("./es-MX-DYxpcVy9.js"), "/src/generated-locales/es.json": () => import("./es-2R3_aXO2.js"), "/src/generated-locales/fr-CA.json": () => import("./fr-CA-DOzO2Vgg.js"), "/src/generated-locales/fr-FR.json": () => import("./fr-FR-50dtzXIn.js"), "/src/generated-locales/ja.json": () => import("./ja-GsULo_wT.js") }), oi = async (e) => {
  try {
    if (e === "pseudo") {
      const n = await Rt["/src/generated-locales/en.json"]();
      return Pt("pseudo", n), Zt(n);
    }
    const t = `/src/generated-locales/${e}.json`, r = Rt[t];
    if (r) {
      const n = await r();
      return Pt(e, n), n;
    }
  } catch (t) {
    console.error("i18n - Failed to import locale:", t);
  }
}, si = () => ai(oi), ui = {
  fallbackLng: {
    ca: ["ca-ES", "ca", "en"],
    fr: ["fr-FR", "en"],
    "ja-JP": ["ja", "en"],
    "es-*": ["es", "en"],
    "en-GB-*": ["en-GB", "en"],
    default: ["en"]
  },
  detection: {
    // An empty array is passed to prevent default localStorage caching
    caches: [],
    lookupQuerystring: "lang_code",
    order: ["querystring", "navigator"]
  },
  nonExplicitSupportedLngs: !0,
  interpolation: { escapeValue: !1 },
  react: {
    useSuspense: !0
  }
}, $ = Dr();
$.use(zt).use(Yt).use(si());
async function hi(e) {
  return $.isInitialized || await $.init({
    ...ui,
    missingKeyHandler: e?.missingKeyHandler,
    saveMissing: !1,
    ...e
  }), $;
}
const Pe = $, li = (e) => {
  const [t, r] = Rr(!1);
  return Re(() => {
    Pe.isInitialized ? r(!0) : (async () => (await hi(), r(!0)))();
  }, []), Re(() => {
    e && t && Pe.changeLanguage(e);
  }, [e, t]), {
    isInitialized: t,
    i18n: Pe
  };
}, fi = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  const t = Cr(({ currentLanguage: n, ...a }, o) => {
    const { i18n: s, isInitialized: h } = li(n);
    return Re(() => {
      n && h && s.changeLanguage(n);
    }, [n, h, s]), h ? Nr?.__serviceI18nGlobalInstance ? k.jsx(e, { ref: o, ...a }) : k.jsx(Or, { i18n: s, children: k.jsx(e, { ref: o, ...a }) }) : null;
  }), r = e.displayName || e.name || "Component";
  return t.displayName = `withI18n(${r})`, t;
};
class Jt extends Error {
  context;
  constructor(t, r = {}) {
    super(t), this.name = "ContextError", this.context = r, Error.captureStackTrace && Error.captureStackTrace(this, Jt);
  }
}
function ci(e) {
  return e instanceof Error && "context" in e && typeof e.context == "object";
}
const pi = ({ errorTrackingClient: e }) => {
  const t = Ar();
  return t && e.captureException(t), "";
}, di = ({ errorTrackingClient: e }) => {
  const t = Ir();
  return t && e.captureException(t), "";
};
class mi extends Ne.Component {
  // needed to get access to "isDataRoute"
  static contextType = wr;
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t, r) {
    this.props.onError?.(t, r);
    const n = ci(t) ? t.context : {};
    this.props.errorTrackingClient.captureException(t, {
      captureContext: {
        extra: {
          ...r,
          ...n
        }
      }
    });
  }
  render() {
    const t = this.context, {
      errorTrackingClient: r,
      errorMessage: n,
      fallback: a,
      children: o
    } = this.props;
    return this.state.hasError || !o ? /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      t && /* @__PURE__ */ k.jsx(di, { errorTrackingClient: r }),
      /* @__PURE__ */ k.jsx(pi, { errorTrackingClient: r }),
      a || /* @__PURE__ */ k.jsx(vi, { errorMessage: n })
    ] }) : o;
  }
}
const vi = /* @__PURE__ */ fi(({ errorMessage: e }) => {
  const { t } = Lr();
  return /* @__PURE__ */ k.jsx(Br, { variant: "critical", children: e || t("errorBoundary.default") });
}), _i = mi;
export {
  Jt as ContextError,
  _i as ErrorBoundary,
  ci as hasErrorContext
};
